import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { ProductImage } from "./ProductImage";

export function ProductCard({ product, testIdPrefix = "product-card" }) {
  const ageLabel =
    product.age_min === -1
      ? "GENITORI"
      : product.age_min === product.age_max
        ? `${product.age_min} anni`
        : `${product.age_min}-${product.age_max} anni`;
  return (
    <Link
      to={`/prodotto/${product.slug}`}
      data-testid={`${testIdPrefix}-${product.slug}`}
      className="group block bg-white border border-[#E8E6E1] rounded-xl overflow-hidden hover:shadow-[0_8px_24px_-12px_rgba(26,54,45,0.18)] hover:-translate-y-0.5 transition-all duration-200"
    >
      <ProductImage product={product} className="w-full aspect-[4/3]" size="md" />
      <div className="p-4">
        <h3 className="font-display text-lg text-[#1A362D] leading-snug line-clamp-2 group-hover:text-[#C05C45] transition-colors">
          {product.name}
        </h3>
        {product.brand_or_author && (
          <p className="mt-1 font-ui text-xs text-[#5C6B64] line-clamp-1">{product.brand_or_author}</p>
        )}
        <div className="mt-3 flex items-center justify-between font-ui text-xs">
          <span className="text-[#8A9691]">{ageLabel}</span>
          <span className="flex items-center gap-1 text-[#1A362D]">
            <Star size={13} className="fill-[#E0A930] text-[#E0A930]" />
            {product.review_count > 0 ? (
              <>
                <span className="font-semibold">{product.avg_rating?.toFixed(1)}</span>
                <span className="text-[#8A9691]">({product.review_count})</span>
              </>
            ) : (
              <span className="text-[#8A9691]">Nuovo</span>
            )}
          </span>
        </div>
      </div>
    </Link>
  );
}
